/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 Card — NS/Tractie component overrides.
// Card extends Paper; Paper-overrides (mui-paper-overrides.ts) regelt elevation/outlined/rounded
// surface keys. MuiCard.root voegt Card-specifieke overflow + radius toe.
// Tractie deviations: borderRadius 6 (Tractie radius-m) ipv MUI default 4 (palette shape).

export const MuiCardLightOverrides = {
  root: {
    overflow: 'hidden' as const,
    borderRadius: 6,
    backgroundColor: 'var(--ns-color-bg-default)',
    transition: 'none',
  },
} as const;

// Dark variant — token --ns-color-bg-default is mode-aware via tokens.css (#fff in light,
// #0d0e10 in dark). Card erft daarom Light overrides integraal; geen mode-specifieke keys.
export const MuiCardDarkOverrides = {
  ...MuiCardLightOverrides,
} as const;
